module.exports = __webpack_public_path__ + "static/rws-service-user-4a1d94ce69388e2ab191d77e84f7449b.jpeg";